import "@/App.css";
import "@/index.css";

// Layout
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";

// Sections
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Skills from "@/components/sections/Skills";
import Projects from "@/components/sections/Projects";
import Contact from "@/components/sections/Contact";

function App() {
  return (
    <div className="App bg-[#050505] min-h-screen">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
